import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../misc';
import classNames from 'classnames';

const GDPRHint = ({ className, faceNote }) => {
  const linkToPrivacy = (
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      <FormattedMessageWrappedInSpan id="gdprHint.link" defaultMessage="privacy policy" />
    </a>
  );

  return (
    <div className={classNames('gdpr-hint-text', className)}>
      { faceNote && <FormattedMessageWrappedInSpan
	  id="gdprHint.face"
	  defaultMessage="We don't store your uploaded selfie."
	/>
      }
      <FormattedMessageWrappedInSpan
        id="gdprHint.text"
        defaultMessage="Learn more about our {link}."
        values={{ link: linkToPrivacy }}
      />
    </div>
  );
};

GDPRHint.defaultProps = {
  faceNote: false
};

GDPRHint.propTypes = {
  className: PropTypes.string,
  faceNote: PropTypes.bool,
};

export default GDPRHint;
